import { render, staticRenderFns } from "./PhoneBrands.vue?vue&type=template&id=57360518&scoped=true&"
import script from "./PhoneBrands.vue?vue&type=script&lang=js&"
export * from "./PhoneBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57360518",
  null
  
)

export default component.exports